/**
 * @file use-is-developer.ts
 * @description 개발자 계정 체크 React Hook
 *
 * 클라이언트 컴포넌트에서 개발자 계정 여부를 확인하는 커스텀 훅입니다.
 * 
 * 개발 모드 플래그(NEXT_PUBLIC_DEV_MODE)가 설정되어 있으면 개발자로 인식합니다.
 * 프로덕션 환경에서는 개발자 체크를 건너뛰고 항상 false를 반환합니다.
 *
 * 사용 예시:
 * ```tsx
 * const { isDeveloper, isLoading } = useIsDeveloper();
 * if (isDeveloper) {
 *   // 개발자 전용 기능 활성화
 * }
 * ```
 */

import { useMemo } from "react";
import { isDeveloper } from "@/lib/utils/check-developer";

export function useIsDeveloper() {
  const isProduction = process.env.NODE_ENV === "production";
  
  // 프로덕션에서는 항상 false, 개발 환경에서는 개발 모드 플래그 확인
  const isDeveloperAccount = useMemo(() => {
    if (isProduction) {
      return false;
    }
    return isDeveloper();
  }, [isProduction]);

  return {
    isDeveloper: isDeveloperAccount,
    isLoading: false, // 동기적 체크이므로 로딩 상태 불필요
  };
}

